import { getQuery } from './getQuery'
import { serializeObject } from './serializeObject'
export const modifyUrl = (url: string, params: Record<string, any>) => {
  const path = url.split('?')[0]
  const queryObject = {
    ...getQuery(url),
    ...params
  }
  return `${path}?${serializeObject(queryObject)}`
}
